<template>
  <div class="daifuDetails-top4">
    <div class="daifuDetails-header_money">
      <div class="touxiang">
        <img :src="info.headimgurl" />
        <div class="t-info">您的好友：{{ info.nickName }}</div>
        <div class="t-t">HI~我需要你的帮助，快来帮我付款吧</div>
      </div>
      <div class="line">
        <img src="https://img.yzcdn.cn/upload_files/2020/10/15/FmtU16DyT-4vtC7NrM_HKYzzL19X.png" />
      </div>
      <div class="main">
        <div class="title">需付款</div>
        <div>
          <!-- <span class="money-icon">￥</span> -->
          <span class="money-num">
            {{ transPrice(info.payOrder.payOrderGoods[0].workbookPrice) }}
          </span>
        </div>
        <div class="time">
          <span style="margin-right:9px">支付剩余时间</span>
          <van-count-down :time="time" @finish="finish">
            <template #default="timeData">
              <span class="vanCount-block">{{ fix(timeData.minutes, 2) }}</span>
              <span class="colon">:</span>
              <span class="vanCount-block">{{ fix(timeData.seconds, 2) }}</span>
            </template>
          </van-count-down>
        </div>
        <div
          class="footer-btn"
          :class="$env.isIos ? 'gray' : ''"
          @click="!$env.isIos ? daiFuPay() : 'return false;'"
        >
          为好友付款
        </div>
        <div v-if="$env.isIos" class="no-pay">* 苹果手机不支持支付，不能为好友付款呦～</div>
      </div>
    </div>
  </div>
</template>

<script>
import { CountDown, Toast } from 'vant'
import { transPrice, fix } from '@/static/js/zjs.js'
export default {
  name: '',
  components: {
    [CountDown.name]: CountDown,
    [Toast.name]: Toast
  },
  props: {
    time: {
      type: Number,
      default: 0
    },
    totalPrice: {
      type: String,
      default: ''
    },
    info: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      payOrderId: '',
      timeCunt: false
    }
  },
  mounted() {

  },
  methods: {
    transPrice,
    fix,
    finish() {
      this.timeCunt = true
    },
    daiFuPay() {
      var payOrderId = this.$route.query.payOrderId || ''
      var params = {
        openid: this.$store.openid,
        channel: 'db_df_n_gn',
        body: this.info.payOrder.payOrderGoods[0].workbookName || '',
        payOrderId: payOrderId,
        description: this.info.payAnotherRecord
          ? this.info.payAnotherRecord.description
          : '我在新华乐子作业答案辅导订阅的课本/练习册，快帮我付款吧，我会感谢你的～'
      }
      console.log(this.timeCunt)
      if (this.timeCunt) {
        Toast({ duration: 3000, message: '系统犯晕中，休息一下\n重新打开页面试试吧～' })
        return false
      }

      if (this.timeCunt) {
        Toast({ duration: 3000, message: '系统犯晕中，休息一下\n重新打开页面试试吧～' })
        return false
      }
      this.$http.post('/cms/weixin/user/book/order/create', params).then((res) => {
        if (res.data) {
          this.payOrderId = res.data.payOrderId
          window.wx.chooseWXPay({
            appId: res.data.appId,
            timestamp: res.data.timeStamp,
            nonceStr: res.data.nonceStr,
            package: res.data.wxpackage,
            signType: res.data.signType,
            paySign: res.data.paySign,
            success: (res) => {
              if (res.errMsg === 'chooseWXPay:ok') {
                this.$parent.getPaySuc()
              } else {
                alert('支付失败:' + res.errMsg + '\n您可以重试或在客服留言咨询.')
              }
            },
            cancel: () => {}
          })
        } else {
          Toast({ duration: 3000, message: '系统犯晕中，休息一下\n重新打开页面试试吧～' })
        }
      })
    }
  }
}
</script>
<style lang="scss" scope>
.daifuDetails-top4 {
  padding: 12px 15px;
  box-sizing: border-box;

  .daifuDetails-header_money {
    width: 343px;
    box-sizing: border-box;
    border-radius: 4px;
    text-align: center;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .touxiang {
      width: 100%;
      background-image: url('https://img.yzcdn.cn/upload_files/2020/10/14/FkKkXfhN75JGqzUI6N94XCmqOddP.png');
      background-size: 100% 100%;
      padding-top: 10px;
      padding-bottom: 20px;
      img {
        width: 54px;
        margin: 0 auto;
        height: 54px;
        border: 2px solid #ffffff;
        box-sizing: border-box;
        filter: drop-shadow(0px 4px 5px rgba(255, 38, 56, 0.05));
        border-radius: 50%;
      }
      .t-info {
        font-weight: 500;
        font-size: 16px;
        margin-top: 10px;
        margin-bottom: 5px;

        color: #333333;
      }
      .t-t {
        font-size: 14px;
        color: #999999;
      }
    }
    .line {
      width: 100%;
      height: 20px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .main {
      width: 100%;
      background: #fff;
      padding-bottom: 16px;
      border-radius: 4px;
      .colon {
        display: inline-block;
        margin: 0 4px;
        color: #000000;
      }
      .vanCount-block {
        display: inline-block;
        width: 20px;
        height: 18px;
        line-height: 18px;
        color: #fff;
        font-size: 12px;
        text-align: center;
        background: #3e4159;
        border-radius: 2px;
      }
    }
    .title {
      font-size: 16px;
      color: #999999;
      margin-bottom: 6px;
    }
    .money-icon {
      font-size: 18px;
      margin-right: 4px;
    }
    .money-num {
      font-size: 32px;
      line-height: 1;
      display: inline-block;
      position: relative;
      &::before {
        content: '￥';
        font-size: 18px;
        position: absolute;
        left: -24px;
        top: 35%;
      }
    }
    .time {
      margin-top: 18px;
      font-size: 14px;
      color: #333333;
      display: flex;
      justify-content: center;
    }
    .footer-btn {
      width: 311px;
      height: 42px;
      font-size: 16px;
      text-align: center;
      line-height: 42px;
      margin-top: 14px;
      display: inline-block;
      color: #ffffff;
      background: linear-gradient(0deg, #ff2638, #ff2638),
        linear-gradient(90deg, #fd735d 0.16%, #fe4e45 100.16%);
      border-radius: 4px;
      &.gray {
        background: #ccc;
      }
    }
    .no-pay {
      font-size: 12px;
      line-height: 17px;
      color: #ff2638;
      margin-top: 12px;
      text-align: left;
      padding-left: 16px;
    }
  }
}
</style>
